const createDownloadCSV=(data)=>{
    const cvsString = data?.map((row)=>row?.join(',')?.join('\n'));

    const blob = new Blob([cvsString], {type: 'text/csv;charset=utf-8;'});

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'data.csv';

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link)
}

export const imageToBlob = (src, fileName) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
    
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
    
          canvas.toBlob((blob) => {
            if (blob) {
              const file = new File([blob], fileName, { type: blob.type, size: blob.size });
              resolve(file);
            } else {
              reject('Failed to convert image to Blob.');
            }
          });
        };
        img.onerror = (err) => reject(err);
        
        img.src = src;
    });
}

/** This is to get phone numbers on for receipts, primarily for online orders.  Used on multiple receipts. 
 * 
 * Order should have a memo or a user that has .mobile_phone or .home_phone
*/
export const figureOutPhone=(order)=>{
        let phone;
        if(order?.memo && order?.memo?.includes("phone_number:")) {
            phone = order.memo.split(":")[1]
        } //user put this one in at checkout, use it - they may be using a temp number, who knows 
        else if(order?.user?.mobile_phone) phone = order?.user?.mobile_phone;
        else if(order?.user?.home_phone) phone = order?.user?.home_phone;
        else phone = ""
        return phone;
    }